export const usePageAnimationStore = defineStore('pageAnimationStore', {
	state: () => ({
		isIndexPageVideoAnimating: true,
        isPageBlocksAnimating: false,
		isEnableScroll: true,
		firstAnimation: true,
		scrollDirection: null,
	}),
	getters: {
		getIndexPageVideoAnimating(state) {
			return state.isIndexPageVideoAnimating;
		},
        getPageCanAnimateBlocks(state) {
			return state.isPageBlocksAnimating;
		},
		getPageEnableScroll(state) {
			return state.isEnableScroll;
		},
		getFirstAnimation(state) {
			return state.firstAnimation;
		},
		getScrollDirection(state) {
			return state.scrollDirection;
		},
	},
	actions: {
		setIndexPageVideoAnimating(value) {
			this.isIndexPageVideoAnimating = value;
		},
        setPageCanAnimateBlocks(value) {
			this.isPageBlocksAnimating = value;
		},
		setPageEnableScroll(value) {
			this.isEnableScroll = value;
		},
		setFirstAnimation(value) {
			this.firstAnimation = value;
		},
		setScrollDirection(value) {
			this.scrollDirection = value;
		},
	}
})